import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const BritishIndianOceanTerritory: Country = {
    identifier: "BritishIndianOceanTerritory",
    name: "British Indian Ocean Territory",
    countryCode: "IO",
    group: CountryGroup.ASIA,
    isUNMember: false,
    flag: "🇮🇴",
    svgPath: "m 678.34275,483.5454 -0.065,0.112 -0.111,0.051 -0.061,-0.283 -0.162,-0.2 0.065,0 0.153,0.102 0.055,0.27 0.057,-0.079 -0.015,-0.084 0.033,-0.079 -0.023,-0.088 -0.084,-0.135 0.029,-0.028 0.134,0.116 0.014,0.093 z",
}
